export default {"src":"/_next/static/media/via_ferrata.7d4627c1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};